import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";
import {getFlatCode, getIdsFromMulipleMeToParent} from "./CommonMethod";
import {childrenKeys} from "../../constant/CodeSpecNum";

export function unSelectCode(compare, v) {
    return compare == v;
}

function isSameSelectedId(leftId, rightId) {
    if (leftId == null || rightId == null) {
        return false;
    }
    return String(leftId) === String(rightId);
}

export function unSelectCodeArray(compare, v) {
    return compare?.some(e =>e?.id===v.id);
}
export function unSelectCoddSub(compare, v) {
    return compare?.some(e =>e?.value?.id===v);
}


export function isRequiredError(required, compare, v) {
    return required && (compare === v);
}

function setStat(f, t, compare, v ) {
    f((prev) => {
        const updatedSearchObject = {...prev};
        if (v == null) {
            delete updatedSearchObject[t];
        } else if (unSelectCode(compare?.id, v.id)) {
            delete updatedSearchObject[t];
        } else {
            updatedSearchObject[t] = v;
        }
        return updatedSearchObject;
    });
}

export function onCreateClickListener(f, t, compare, v) {
    setStat(f, t, compare, v);
}

function setSearchStat(f, t, compare, v ) {
    const next = {...compare};
    if (v == null || isSameSelectedId(compare[t]?.id, v?.id)) {
        next[t] = null;
    } else {
        next[t] = v;
    }
    f(next);
}

function setSearchChildrenStat(f, t, compare, v ) {
    const next = {...compare};
    const keys = childrenKeys[t];

    if (v == null || isSameSelectedId(compare[t]?.id, v?.id)) {
        next[t] = null;
        if (keys) {
            next[keys] = null;
        }
    } else {
        next[t] = v;
        if (keys) {
            next[keys] = getFlatCode([v]);
        }
    }
    f(next);
}

function setSearchStat_iter(f, u, t, compare, dto, v) {
    if (v == null) {
        f((prev) => {
            const updatedState = prev.filter((e) => e.index != dto.index);
            const list = updatedState
                .filter(Boolean)
                .map((item) => item.id);
            const idAndIndex = updatedState
                .map((item) => item ? {id: item.id, index: item.index, name: item.name} : null)
                .filter(Boolean);
            u({[dto.fieldName]: list, savedSub: idAndIndex});
            return updatedState;
        });
        return;
    }

    v.index = dto.index;

    const exist = compare.some((e) => isSameSelectedId(e.id, v.id));

    f((prev) => {
        // v가 존재하면 기존 요소에서 제거하고, 아니면 추가
        const updatedState = exist
            ? prev.filter(e => e.index != v.index) // v가 이미 존재하면 제거
            : [...prev.filter(e => e.index != v.index), v]; // v가 존재하지 않으면 추가

        // id를 추출한 리스트 생성
        const list = updatedState
            .filter(Boolean) // null 또는 undefined 제거
            .map((item) => item.id);
        // 검색조건을 위해 임시로 추가됨
        const idAndIndex = updatedState
            .map((item, index) => item ? { id: item.id, index:item.index, name:item.name } : null)
            .filter(Boolean);
        // u에 list 업데이트
        u({ [dto.fieldName]: list, savedSub:idAndIndex });

        return updatedState; // 병합 결과 반환
    });
}






export function searchListener(f, t, compare, v) {
    setSearchStat(f, t, compare, v);
}

export function searchWithChildren(f, t, compare, v) {
    const keys = childrenKeys[t];
    if (v && typeof v === "object" && Array.isArray(v.__multiFlat)) {
        const next = {...compare};
        if (v.__multiFlat.length === 0) {
            next[t] = null;
            if (keys) {
                next[keys] = null;
            }
        } else {
            next[t] = null;
            if (keys) {
                next[keys] = v.__multiFlat;
            }
        }
        f(next);
        return;
    }

    setSearchChildrenStat(f, t, compare, v);
}

export function ITER_searchListener(f, u, t, compare, dto, v) {
    setSearchStat_iter(f, u, t, compare, dto, v);
}


function setStatAndId(setState, t, name, compare, value) {
    setState((prev) => {
        const updatedSearchObject = {...prev};
        if (unSelectCode(compare?.id, value.id)) {
            delete updatedSearchObject[t];
            delete updatedSearchObject[name];
        } else {
            updatedSearchObject[t] = value;
            updatedSearchObject[name] = value.id;
        }
        return updatedSearchObject;
    });
}

export function onCreateIdClickListener(f, t, name, compare, v) {
    setStatAndId(f, t, name,compare, v);
}

export function onUpdate(f, t, name, compare, v, update) {
    setStatAndId(f, t, name,compare, v);
    if (update) {
        update(v.id, name);
    }
}

export async function onUpdateClickListener(f, u, t, data, v, required) {
    if(isRequiredError(required, data[t]?.id, v.id)){
        alert('필수값이므로 제거할 수 없습니다.')
        return
    }
    ;
    const updateObj = {
        id: data.id,
        fieldName: t,
        value: unSelectCode(data[t]?.id, v.id) ? null : v.id,
    }
    getToastMessageByApi(u, updateObj,()=>setStat(f, t, data[t], v));
}



export function onSubCreateClickListener(f, t, compare, dto, v) {
    // setCreateSubState(f, dto, compare, v, t);
    setSubState(f, dto, compare, v, t);
}


export function onSubCreateClickListenerId(f, t, compare, dto, v) {
    setSubStateId(f, dto, compare, v, t);
}


export async function onSubUpdateClickListener(f, u, t, compare, dto, v) {

    const updateObj ={
        id: dto.id,
        fieldName: dto.fieldName,
        value: unSelectCode(compare?.id, v.id)  ? null : v.id,
        subId: dto.subId,
    }
    getToastMessageByApi(u, updateObj,()=> setSubState(f, dto, compare, v, t));
}

export async function onSubUpdateUserListener(f, u, t, compare, dto, v) {
    const updateObj ={
        id: dto.id,
        fieldName: dto.fieldName,
        value: unSelectCode(compare, v.id)  ? null : v.id,
        subId: dto.subId,
    }

    getToastMessageByApi(u, updateObj,()=>setSubStateId(f, dto, compare, v, t));

}

////////////////////////
function setCreateSubState(f, dto, compare, v, t) {
    f(prevState => {
        const newState = {...prevState};
        const obj = {
            [dto.subName]: {id: dto.subId},
            [dto.fieldName]: unSelectCode(compare?.id, v.id) ? null : v,
        };
        const targetArray = [...(newState[t] || [])];
        targetArray[dto.index] = obj;
        newState[t] = targetArray;
        return newState;
    });
}

function setSubState(f, dto, compare, v, t) {
    f(prevState => {
        const newState = { ...prevState };
        const targetArray = [...(newState[t] || [])];

        let found = false;
        const updatedArray = targetArray.map(item => {
            if (item[dto.subName]?.id === dto.subId) {
                found = true;
                return {
                    ...item,
                    [dto.fieldName]: unSelectCode(compare?.id, v.id) ? null : v
                };
            }
            return item;
        });

        if (!found) {
            updatedArray.push({
                [dto.subName]: { id: dto.subId },
                [dto.fieldName]: unSelectCode(compare?.id, v.id) ? null : v
            });
        }

        newState[t] = updatedArray;
        return newState;
    });
}


function setSubStateId(f, dto, compare, v, t) {
    f(prevState => {
        const newState = {...prevState};
        const obj = {
            [dto.subName]: {id: dto.subId},
            [dto.fieldName]: unSelectCode(compare, v.id) ? null : v.id,
        };
        const targetArray = [...(newState[t] || [])];

        const targetIndex = targetArray.findIndex(
            item => item?.[dto.subName]?.id === dto.subId
        );

        if (targetIndex !== -1) {
            targetArray[targetIndex] = obj;
        }else{
            targetArray[dto.index] = obj;
        }

        newState[t] = targetArray;
        return newState;
    });
}


function setSubUser(f, dto, compare, v, t) {
    f(prevState => {
        const newState = {...prevState};
        const obj = {
            [dto.subName]: {id: dto.subId},
            [dto.fieldName]: unSelectCode(compare, v.id) ? null : v.id,
        };
        const targetArray = [...(newState[t] || [])];
        targetArray[dto.index] = obj;

        newState[t] = targetArray;
        return newState;
    });
}

export const searchOnchangeHandler = (dataSet, e, l, f, r, resetOthers = true) => {
    let filteredData= []
    const content = dataSet.content
    if(content.length == 0) return;

    // 검색어가 drawer상에 나타나는 key값을 넣어줘야함
    const array = r ? getFlatCode(content) : content;
    const target = Object.keys(array[0]).find(each => "name" === each || "assetName" === each || "title" === each) ?? "";
    filteredData = array.filter(item => item[target].toLowerCase().includes(e.target.value.toLowerCase()))

    const idsFromParentToSelectedCode = e.target.value.trim() !== ''? getIdsFromMulipleMeToParent(filteredData, content) : []

    if (resetOthers) {
        findCodesBySearchTxt(idsFromParentToSelectedCode, l, f);
    } else {
        f((prev) => {
            const updated = { ...prev };
            idsFromParentToSelectedCode.forEach((id) => {
                updated[id] = true;
            });
            return updated;
        });
    }
}

function findCodesBySearchTxt (idsFromParentToSelectedCode, l, f){
    const updatedExpandedMenus = { ...l };
    idsFromParentToSelectedCode
        .forEach(id => {
            updatedExpandedMenus[id] = true;
        });

    Object.keys(updatedExpandedMenus).forEach(id => {
        updatedExpandedMenus[id] = idsFromParentToSelectedCode.includes(Number(id));
    });

    f(updatedExpandedMenus);
}

// function findCodesBySearchTxt (idsFromParentToSelectedCode, l, f){
//     f(prev => {
//         const updated = { ...prev };
//         idsFromParentToSelectedCode.forEach(id => {
//             updated[id] = true;  // 열어야 하는 것만 true로
//         });
//         return updated;        // 나머지는 그대로 (닫지 않음)
//     });
// }

function getToastMessageByApi(u, updateObj, f) {
    u(updateObj).then(r => {
            if (r.status === 200) {
                handleActiveToast({
                    description: "", message: "수정 되었습니다.", labelListener: () => {
                    }
                })
                f();
            } else if (r.status === 201 || (r.status === 202)) {
                handleActiveError({message: r.data.title, description: r.data.reason});
            } else {
                handleActiveError({message: '처리실패', description: '알수 없는 에러'});
            }
        }
    );
}



export function onClickToAdd(f, t, compare, v) {
    setStatArray(f, t, compare, v);
}


export function diligenceHandlerOnUpdate(f, u, id, t, compare, v, required) {
    const unselect = unSelectCodeArray(compare, v)
    if(required && unselect && compare.length <=1) {alert("필수값 이므로 최소한 하나의 요소가 필요합니다."); return;}
    u(id, v.id, !unselect).then(r=>{

        if(r.status=200){
            handleActiveToast({
                description: "", message: "수정 되었습니다.", labelListener: () => {
                }
            })
            setStatArray(f, t, compare, v);
        }else{
            handleActiveToast({
                description: "알 수 없는 에러", message: "수정에 실패했습니다.", labelListener: () => {
                }
            })
        }
    })

}


export function diligenceAssetsOnUpdate(f,u, id, t, compare, v, required) {
    const unselect = unSelectCodeArray(compare, v)
    if(required && unselect && compare.length <=1) {alert("필수값 이므로 최소한 하나의 요소가 필요합니다."); return;}
    u(id, v.id, !unselect).then(r=>{
        if(r.status=200){
            handleActiveToast({
                description: "", message: "수정 되었습니다.", labelListener: () => {
                }
            })
        }else{
            handleActiveToast({
                description: "알 수 없는 에러", message: "수정에 실패했습니다.", labelListener: () => {
                }
            })
        }
    })


    f((prev) => {
        const updatedSearchObject = { ...prev };
        if (!Array.isArray(updatedSearchObject[t])) {
            updatedSearchObject[t] = [];
        }
        if (unselect) {
            updatedSearchObject[t] = updatedSearchObject[t].filter(item => item.asset.id !== v.id);
        } else {
            const obj = {
                asset:v
            }
            updatedSearchObject[t] = [...updatedSearchObject[t], obj];
        }

        return updatedSearchObject;
    });
}


export function diligenceAssetsOnChanger(f, t, compare, v) {
    f((prev) => {
        const updatedSearchObject = { ...prev };
        if (!Array.isArray(updatedSearchObject[t])) {
            updatedSearchObject[t] = [];
        }
        if (updatedSearchObject[t].some(each=>each.asset.id === v.id)) {
            updatedSearchObject[t] = updatedSearchObject[t].filter(item => item.asset.id !== v.id);
        } else {
            const obj = {
                asset:v
            }
            updatedSearchObject[t] = [...updatedSearchObject[t], obj];
        }

        return updatedSearchObject;
    });
}


export function onClickToList(f, t, compare, v) {
    f((prev) => {
        let updatedSearchObject =  [...(prev || [])];
        if (unSelectCodeArray(compare, v)) {
            updatedSearchObject = updatedSearchObject.filter(item => item.id !== v.id);
        } else {
            updatedSearchObject = [...updatedSearchObject, v];
        }

        return updatedSearchObject;
    });
}


export function onClickToAddIds(f, t, compare, v) {
    setStatArray(f, t, compare, v);
    const handlerIds = 'handlerIds';
    f((prev) => {
        const updatedSearchObject = { ...prev };
        if (!updatedSearchObject[handlerIds]) {
            updatedSearchObject[handlerIds] = [];
        }
        if (updatedSearchObject[handlerIds].includes(v.id)) {
            updatedSearchObject[handlerIds] = updatedSearchObject[handlerIds].filter(id => id !== v.id)
        } else {
            updatedSearchObject[handlerIds].push(v.id);
        }
        return updatedSearchObject;
    });
}



function setStatArray(f, t, compare, v) {
    f((prev) => {
        const updatedSearchObject = { ...prev };
        if (!Array.isArray(updatedSearchObject[t])) {
            updatedSearchObject[t] = [];
        }
        if (unSelectCodeArray(compare, v)) {
            updatedSearchObject[t] = updatedSearchObject[t].filter(item => item.id !== v.id);
        } else {
            updatedSearchObject[t] = [...updatedSearchObject[t], v];
        }

        return updatedSearchObject;
    });
}


export function subSearchObjectListener(f,u, value, compare, dto){
    // const flatList = typeof value === "object" ? getFlatCode([value]) : value;
    const flatList = Array.isArray(value) ? getFlatCode(value) : value && typeof value === "object" ? getFlatCode([value]) : value;
    const keys = childrenKeys[dto.t];

    if (compare[dto.t]?.id === value.id) {
        delete compare[dto.t];
        if(keys) delete compare[keys];
    } else {
        compare[dto.t] = value;
        if(keys) compare[keys] = flatList;
    }
    u(compare);

    // subSelected에서 해당 값 삭제
    f(prevState => {
        const newState = { ...prevState }; // 이전 상태 복사
        if (newState[dto.t]?.id === value.id) {
            delete newState[dto.t]; // 값 삭제
            if(keys) delete compare[keys];
        } else {
            newState[dto.t] = value; // 값 추가
            if(keys) compare[keys] = flatList;
        }
        return newState; // 새로운 상태 반환
    });
}

export function subSearchRawValueListener(f, u, value, compare, dto){
    const v = (value ?? "").trim();

    if (!v) {
        delete compare['searchTxt'];
        u(compare);
    } else {
        compare['searchTxt'] = value
        u(compare);
    }
    
    f(prevState => {
        const newState = { ...prevState }; // 이전 상태 복사
        if (!v) {
            delete newState['searchTxt']; // 값 삭제
        } else {
            newState['searchTxt'] = value; // 값 추가
        }
        return newState; // 새로운 상태 반환
    });
}
